import { accountCopy } from '@/copy'
import { TabBar, TabPanel } from '@/ui/TabBar/TabBar'
import { WsPageShell } from '../components/WsPageShell'
import { useFeatures } from '../hooks/queries'
import { useTabParam } from '../hooks/useTabParam'
import { AccountTab } from './settings/AccountTab'
import { BillingTab } from './settings/BillingTab'

// Appearance lives in the sidebar footer's ◐ popover (color / text size),
// not in settings.
type Tab = 'account' | 'billing'

const TABS: readonly Tab[] = ['account', 'billing']

const { page } = accountCopy

export function SettingsPage() {
  const features = useFeatures()
  // The active tab lives in ?tab= so deep links (ROUTES.settingsBilling) work
  // and the URL never desyncs from the visible tab.
  const [tab, setTab] = useTabParam(TABS, 'account')

  return (
    <WsPageShell crumbs={[]} title={page.title} description={page.description}>
      {/* Only the tab button is gated — `tab` still resolves from the full
          TABS list, so a ?tab=billing deep link keeps working even before
          /api/version resolves. */}
      <TabBar
        label={page.sections}
        tabs={[
          { id: 'account', label: page.tabs.account },
          ...(features.billing
            ? [{ id: 'billing', label: page.tabs.billing }]
            : []),
        ]}
        active={tab}
        onChange={(id) => setTab(id as Tab)}
      >
        <TabPanel id="account">
          <AccountTab />
        </TabPanel>
        <TabPanel id="billing">
          <BillingTab />
        </TabPanel>
      </TabBar>
    </WsPageShell>
  )
}
